import styled, { createGlobalStyle } from 'styled-components'
import { Theme } from './themes/dark'

const EstiloGlobal = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  font-family: 'Fira Code', monospace;
  list-style: none;

}

body {
  padding-top: 80px ;
  padding-bottom: 80px;
  background-color: ${(props) => (props.theme as Theme).corDeFundo};
  a {
    text-decoration: none;
  }
  @media (max-width: 768px) {
    padding: 20px;
  }
}`

export default EstiloGlobal

export const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 128px auto;
  column-gap: 56px;

  @media (max-width: 768px) {
    max-width: 80%;
    display: block;
  }
`
